import React from 'react';
import { JcImage, JcImageProps } from './JcImage';
import { JcPlaceholder } from './JcPlaceholder';
import { JcSize, JcUtils } from '../utils/JcUtils';

export interface JcImageWithPlaceholderProps extends Omit<JcImageProps, "url"> {
    readonly url: string | null;
    readonly placeholder: React.ReactNode;
}

export const JcImageWithPlaceholder: React.FunctionComponent<JcImageWithPlaceholderProps> = (
    props: JcImageWithPlaceholderProps
) => {
    const { url, size, placeholder, circle, ...otherProps } = props;
    const commonProps = JcUtils.commonProps(otherProps, [
        "jc-image-with-placeholder",
        size !== JcSize.NONE && ("jc-image-with-placeholder-size-" + size),
        circle && "jc-image-circle",
    ]);
    const otherImageProps = JcUtils.otherProps(otherProps);
    if (url) {
        return <JcImage size={JcSize.NONE} {...otherImageProps} {...commonProps} url={url} />;
    }
    // The placeholder stands in for the image, so it keeps the image's accessible name.
    return <JcPlaceholder {...commonProps} role="img" ariaLabel={props.alt}>
        {placeholder}
    </JcPlaceholder>;
};
